/* eslint-disable react/prop-types */
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import * as React from "react";
import fixTableCellWidth from "../../../utils/fixTableCellWidth";
import separate from "../../../utils/separate";

function createData(id, amount, created_at, type_name) {
  return {
    id,
    amount,
    created_at,
    type_name,
  };
}

function Row(props) {
  const { row } = props;

  return (
    <React.Fragment>
      <TableRow
        sx={{ "& > *": { borderBottom: "unset" }, backgroundColor: row.id % 2 === 1 ? "" : "rgba(204,204,204,0.1)" }}>
        <TableCell className="tablecell" align="left" title={separate(Number(row.amount))}
                   style={fixTableCellWidth("140px")}>{separate(Number(row.amount))} تومان</TableCell>
        <TableCell className="tablecell" align="left" title={row.type_name}
                   style={fixTableCellWidth("110px")}>{row.type_name}</TableCell>
        <TableCell className="tablecell" align="left" title={new Date(row.created_at).toLocaleString("fa-IR")}
                   style={fixTableCellWidth("170px")}>{new Date(row.created_at).toLocaleString("fa-IR")}</TableCell>
      </TableRow>
    </React.Fragment>
  );
}

export default function Transactions({ singleGhollak }) {
  const rows = singleGhollak?.transactions?.map(item => createData(item.id, item.amount, item?.created_at, item.type_name,
  ));
  return (
    <>
      {singleGhollak?.transactions.length === 0 ? <p style={{ fontSize: 16 }}>تراکنشی ثبت نشده است!</p> :
        <TableContainer component={Paper}>
          <Table>
            <TableHead sx={{ padding: 0 }}>
              <TableRow>
                <TableCell className="tablecell" style={fixTableCellWidth("150px")}>مقدار</TableCell>
                <TableCell className="tablecell" style={fixTableCellWidth("110px")}>نوع</TableCell>
                <TableCell className="tablecell" style={fixTableCellWidth("150px")}>تاریخ ایجاد</TableCell>
              </TableRow>
            </TableHead>
            <TableBody style={{ display: "block" }}>
              {rows.map((row) => (
                <Row key={row.id} row={row} />
              ))}
            </TableBody>
          </Table>
        </TableContainer>}
    </>
  );
}
